import React from 'react';
import { useAlert } from 'react-alert';
import { useTranslation } from 'react-i18next';
import {
  CurrencyField,
  DataTable,
  DateTimeField,
  Field,
  PercentageField,
} from '../../commons/DataTable';
import CustomerVatCodeField from '../../commons/DataTable/CustomerVatCodeField';
import CustomerTypeField from '../../commons/DataTable/CustomerTypeField';
import CustomerNameField from '../../commons/DataTable/CustomerNameField';
import AdminField from '../../commons/DataTable/AdminField';

function DashboardDetailTable(props) {
  const {
    data = [],
    total = 0,
    topRow,
    bottomRow,
    onFilter,
    query = {},
  } = props;

  const alert = useAlert();
  const [t] = useTranslation('COMMON');
  const { offset, limit } = query;

  return (
    <DataTable
      history
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      loadingText={t('LOADING')}
      emptyText={t('NO_DATA')}
      topRow={topRow}
      bottomRow={bottomRow}
      onFilter={onFilter}
    >
      <Field title="Rami" source="branch" />
      <Field title="Codice polizza" source="policy_code" sticky={true} />
      <Field title="Etichetta polizza" source="insurance_code" sticky={true} />
      <AdminField title="Referente" source="admin.businessName" sticky={true} />
      <Field title="Codice fiscale referente" source="admin.taxCode" />
      <Field title="Fornitore" source="supplier.businessName" sticky={true} />
      <Field title="Codice fiscale fornitore" source="supplier.taxCode" />
      <Field title="Tipo agenzia" source="agencyType" sticky={true} />
      <CustomerNameField title="Cliente" source="customer.name" sticky={true} />
      <CustomerVatCodeField title="P.Iva / Codice fiscale cliente" />
      <CustomerTypeField title="Tipologia cliente" source="customerType" />
      <DateTimeField
        title="Data inizio"
        source="start_date"
        format="DD/MM/YYYY"
      />
      <DateTimeField title="Data fine" source="end_date" format="DD/MM/YYYY" />
      <Field title="Fraz" source="fraz" />
      <CurrencyField
        title="Premio lordo"
        source="gross"
        className="txt-table-right"
      />
      <CurrencyField
        title="Premio netto"
        source="net"
        className="txt-table-right"
      />
      <CurrencyField
        title="ROY La Panoramica"
        source="shareToInvoice"
        className="txt-table-right"
      />
      <PercentageField
        title="ROY La Panoramica %"
        source="shareToInvoicePerc"
        className="txt-table-right"
      />
      <CurrencyField
        title="Profitto La Panoramica"
        source="panoramicaShare"
        className="txt-table-right"
      />
      <CurrencyField
        title="Profitto Sub Agenzia"
        source="adminShare"
        className="txt-table-right"
      />
      <PercentageField
        title="Profitto Sub Agenzia %"
        source="subAgencyPerc"
        className="txt-table-right"
      />
      <CurrencyField
        title="Quota responsabile maturata"
        source="earnedAdminShare"
      />
      <CurrencyField
        title="Diritto a fatturare responsabile"
        source="billableAdminShare"
      />

      <CurrencyField
        title="Quota responsabile di zona"
        source="commercial.share"
      />
      <CurrencyField
        title="Quota responsabile di zona maturata"
        source="commercial.earnedShare"
      />
      <CurrencyField
        title="Diritto a fatturare responsabile di zona"
        source="commercial.billableShare"
      />

      <CurrencyField title="Quota commerciale 1" source="commercial2.share" />
      <CurrencyField
        title="Quota commerciale 1 maturata"
        source="commercial2.earnedShare"
      />
      <CurrencyField
        title="Diritto a fatturare commerciale 1"
        source="commercial2.billableShare"
      />

      <CurrencyField title="Quota commerciale 2" source="commercial3.share" />
      <CurrencyField
        title="Quota commerciale 2 maturata"
        source="commercial3.earnedShare"
      />
      <CurrencyField
        title="Diritto a fatturare commerciale 2"
        source="commercial3.billableShare"
      />
    </DataTable>
  );
}

export default DashboardDetailTable;
